module.exports = require("/home/runner/work/graphql-platform/graphql-platform/website/src/state")